import _ from "lodash";

export function getProjContractorOptions(projContractorList) {
  let pcOptions = [];

  // First item is the prime contractor. If no prime is found, skip.
  const primeContr = (projContractorList || []).find((pc) => pc.isPrime);
  if (primeContr)
    pcOptions.push({
      value: primeContr.contractorId,
      label: `${primeContr.name} (P)`,
      role: "Prime",
    });

  // Get all subs ordered alphatically in a sub array
  const subOptions = _.orderBy(
    (projContractorList || [])
      .filter((pc) => !pc.isPrime && !pc.isSupplier)
      .map((pc) => ({ value: pc.contractorId, label: pc.name, role: "Sub" })),
    "label",
    "asc"
  );

  const suppOptions = _.orderBy(
    (projContractorList || [])
      .filter((pc) => pc.isSupplier)
      .map((pc) => ({ value: pc.contractorId, label: `${pc.name} (Supplier)`, role: "Supplier" })),
    "label",
    "asc"
  );

  pcOptions = [...pcOptions, ...subOptions, ...suppOptions];
  return pcOptions;
}
